
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7078/api/',
    //Live
    apiUrl: 'https://inn-api.off-ease.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;

